import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { BULK_BTN_SIZE } from '../virtualList/constants.ts';

import { BulkAdd } from './BulkAdd.tsx';
import { StyledBulkInputPlusSignIcon } from './BulkInputPlusSignIcon.styled.tsx';
import { StyledBulkPlaceholderDiv } from './BulkPlaceholderDiv.styled.tsx';
import { useBulkAdd } from './hooks/useBulkAdd.ts';
import type { BulkValidationReturnType } from './types.ts';

export type BulkInputProps = {
  isDisabled: boolean;
  validate: (items: string[]) => BulkValidationReturnType;
  onAdd: (items: string[]) => void;
};

export const BulkInput = ({ validate, onAdd, isDisabled }: BulkInputProps) => {
  const { t } = useTranslation();
  const { isBulkOpen, onBulkAdd, onBulkClose, onBulkOpen } = useBulkAdd({ onAdd });

  return isBulkOpen ? (
    <>
      <StyledBulkPlaceholderDiv height={BULK_BTN_SIZE} />
      <BulkAdd onApply={onBulkAdd} onClose={onBulkClose} validate={validate} isDisabled={isDisabled} />
    </>
  ) : (
    <StyledBulkPlaceholderDiv height={BULK_BTN_SIZE} onClick={onBulkOpen}>
      <Button variant="text" disabled={isDisabled}>
        <StyledBulkInputPlusSignIcon size={24} /> <Typography variant="button">{t('Bulk add')}</Typography>
      </Button>
    </StyledBulkPlaceholderDiv>
  );
};
